import { Box, Button, Dialog, DialogActions, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@emotion/react';
import UploadFile from './UploadFile';
import AddShip from './AddShip';
import TabPanel from '../../../../components/TabPanel';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};



function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AddShipTabPanel({ onModelHandleClose, modelOpen, partyInfo }) {
  const theme = useTheme();
  const [tabIndexValue, setValue] = React.useState(0);
  const {t} = useTranslation()

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // setCompanyManagementList([]);
    // setPayload((prev) => ({ ...prev, limt: 10, paginationPage: 0, page: 1, filter: null }));
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        flex={1}
        style={{}}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
          style={{ paddingLeft: '0px', paddingRight: '24px', borderBottomWidth: 1, borderBottomColor: '#0000000D' }}
        >
          <Tabs
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#FFCC00 !important',
            },
          }}
            indicatorColor="primary"
            value={tabIndexValue}
            onChange={handleChange}
          >
            <Tab
              className="!uppercase !text-#14285A fw-medium ff-Roboto fs-16"
              label={t('Add ship')}
              {...a11yProps(0)}
            />
            {/* <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label={t('Upload')}
              {...a11yProps(1)}
            /> */}
          </Tabs>
          <div>
            <IconButton onClick={() => onModelHandleClose(false)}>
              <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
            </IconButton>
          </div>
        </Stack>

        <TabPanel
          className="flex flex-col flex-1 min-h-0"
          value={tabIndexValue}
          index={0}
        >
            <AddShip
              partyInfo={partyInfo}
              onModelHandleClose={() => onModelHandleClose(true)}
            />
        </TabPanel>
        {/* {tabIndexValue === 1 && <TabPanel
          className="flex flex-col flex-1 min-h-0"
          value={tabIndexValue}
          index={1}
        >
          <UploadFile />
        </TabPanel>} */}
      </Stack>
    </Dialog>
  );
}
